/** Normalize company name: remove diacritics, uppercase, trim */
export function normalizeCompany(name) {
  if (!name) return "";
  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();
}

const LS_KEY = "povinnosti_companies";

export function loadCompanyList() {
  try {
    const stored = localStorage.getItem(LS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function saveCompanyList(list) {
  localStorage.setItem(LS_KEY, JSON.stringify(list));
}

/** Merge and deduplicate two arrays of normalized company names, sorted */
export function mergeCompanyLists(listA, listB) {
  return [...new Set([...listA, ...listB])].sort();
}

// --- ZOZNAM POVINNOSTÍ ---

/** Predvolené názvy povinností zo katalógu kalkulačky */
export const KALKULACKA_SERVICE_NAMES = [
  // Paušálne
  'Jednoduché účtovníctvo – neplatca DPH',
  'Jednoduché účtovníctvo – platca DPH',
  'Podvojné účtovníctvo – neplatca DPH',
  'Podvojné účtovníctvo – platca DPH',
  // Položkové účtovníctvo
  'VFA (vyšlé faktúry)',
  'DFA (došlé faktúry)',
  'Pohľadávky',
  'Záväzky',
  'Banka – príjmy aj výdaje',
  'Pokladňa – príjmy aj výdaje',
  'ID (interné doklady)',
  'Podanie DPH a KV k DPH',
  'Podanie DP k DPH',
  'Vystavovanie faktúr',
  'Príplatok za neúplne dodané podklady',
  'Príplatok za zrýchlené spracovanie',
  'Komplexné spracovanie majetku na úver/splátky',
  'Ľahké zaradenie majetku',
  // Mzdy
  'Spracovanie mzdy',
  'Registrácia zamestnávateľa (SP, ZP, DÚ)',
  'Registrácia zamestnanca (SP, ZP)',
  'Odhlásenie zamestnanca',
  'Pracovná zmluva / dodatok',
  'Ročné zúčtovanie dane',
  'Ročné hlásenie dane',
  // Controlling
  'Predbežný HV',
  'Analytický výstup',
  'Cashflow forecast',
  'Mesačný komentovaný report',
  'Optimalizácia nákladov',
  'Rozpočtovanie / budget',
  'Finančný plán firmy',
  // Daňové
  'Účtovná závierka PO',
  'Daňové priznanie PO',
  'Daňové priznanie FO typ B (paušál)',
  'Daňové priznanie FO typ B s účtovnou závierkou',
  'Daňové priznanie FO typ A',
  'Daň z motorových vozidiel',
  'Dobrovoľná registrácia na DPH',
  'Predzávierkové operácie a kontrola',
  // Doplnkové
  'Kniha jázd',
  'Cestovný príkaz',
  'Žiadosť o vrátenie DPH zo zahraničia',
  'Excel / reporty pre klienta',
  'Smernice, interné dokumenty',
  // Zakladanie
  'Založenie s. r. o.',
  'Zmena v s. r. o.',
  'Založenie živnosti',
  'Zmena v živnosti',
  'Zrušenie živnosti',
  'Založenie občianskeho združenia',
  // Všeobecné
  'mesačné účtovníctvo',
  'prihlasenie zamestnanca',
];

/** Normalize task name: trim, lowercase first letter kept, trim whitespace */
export function normalizeTaskName(name) {
  if (!name) return "";
  return name.trim();
}

const TS_KEY = "povinnosti_tasks";

export function loadTaskList() {
  try {
    const stored = localStorage.getItem(TS_KEY);
    const saved = stored ? JSON.parse(stored) : [];
    return mergeTaskLists(saved, KALKULACKA_SERVICE_NAMES);
  } catch {
    return [...KALKULACKA_SERVICE_NAMES];
  }
}

export function saveTaskList(list) {
  localStorage.setItem(TS_KEY, JSON.stringify(list));
}

/** Merge and deduplicate two arrays of task names, sorted */
export function mergeTaskLists(listA, listB) {
  return [...new Set([...listA, ...listB])].sort((a, b) => a.localeCompare(b, "sk"));
}
